<div class="animated fadeInRight main-view-big" style="padding: 24px;">
  <!-- Profilbild -->
  @if (!ProfilBild && !HasOriginalProfilBild) {
    <div class="rmpm dropzone"
      style="width:240px; height:240px; cursor: pointer;" appDragDrop (files)="filesDropped($event)"
      (click)="fileUpload.click()">
      @if (!ProfilBild && !HasOriginalProfilBild) {
        <div class="text-wrapper">
          <div class="centered">
            <mat-icon style="font-size: 64px; width:64px; height: 64px; opacity: 0.2;">perm_identity</mat-icon>
            <BR>
            {{'BildUploadInfo' | translate}}
          </div>
        </div>
      }
    </div>
  }

  @if (ProfilBild) {
    <div class="profile-div">
      <img [src]="ProfilBild.url" class="profile-pic" appDragDrop (files)="filesDropped($event)"
        (click)="fileUpload.click()">
        <button mat-mini-fab (click)="clearPicture()" class="profile-button"
          matTooltip="{{'Stammdaten.BildAbrechen' | translate}}">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    }

    @if (!ProfilBild && HasOriginalProfilBild) {
      <div class="profile-div">
        <img [src]="OriginalProfilBild" class="profile-pic" appDragDrop (files)="filesDropped($event)"
          (click)="fileUpload.click()">
          <button mat-mini-fab (click)="deletePicture()" class="profile-button"
            matTooltip="{{'Stammdaten.BildLöschen' | translate}}">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }

      @if (this.isLoading) {
        <div>
          <mat-progress-bar mode="indeterminate" style="margin-top: 4px; margin-bottom: 4px;"></mat-progress-bar>
        </div>
      }

      <input hidden (change)="handleFileInput($event.target.files)" #fileUpload type="file" accept=".jpg,.jpeg"
        id="filePick">
        <!-- Person -->
        @if (!stammdaten.IstInstitution) {
          <div>
            <!-- Anrede und Titel -->
            @if (this.stammdaten.Titel != 20) {
              <div class="row no-padding">
                <div class="col-md-6 col-left">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Stammdaten.Anrede' | translate}}</mat-label>
                    <mat-select [(ngModel)]="this.stammdaten.Anrede" required
                      placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                      <mat-option [value]="1">{{'Neuauftrag.Arzt.Anrede.Herr' | translate}}</mat-option>
                      <mat-option [value]="2">{{'Neuauftrag.Arzt.Anrede.Frau' | translate}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-right">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
                    <mat-select [(ngModel)]="this.stammdaten.Titel">
                      @for (titel of this.oroservice.kundeninfo.Titel; track titel) {
                        <mat-option [value]="titel.Id">
                          {{titel.Name}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            }
            <!-- Anrede und Titel -->
            @if (this.stammdaten.Titel == 20) {
              <div class="row no-padding">
                <div class="col-md-4 col-left">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Stammdaten.Anrede' | translate}}</mat-label>
                    <mat-select [(ngModel)]="this.stammdaten.Anrede" required
                      placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                      <mat-option [value]="1">{{'Neuauftrag.Arzt.Anrede.Herr' | translate}}</mat-option>
                      <mat-option [value]="2">{{'Neuauftrag.Arzt.Anrede.Frau' | translate}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-4 col-middle">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
                    <mat-select [(ngModel)]="this.stammdaten.Titel" required
                      placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                      @for (titel of this.oroservice.kundeninfo.Titel; track titel) {
                        <mat-option [value]="titel.Id">
                          {{titel.Name}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-4 col-right">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
                    <input matInput [(ngModel)]="this.stammdaten.TitelSonstige" type="text">
                  </mat-form-field>
                </div>
              </div>
            }
            <!-- Person Name -->
            <div class="row no-padding">
              <div class="col-md-6 col-left">
                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                  <mat-label>{{'Vorname' | translate}}</mat-label>
                  <input matInput [(ngModel)]="stammdaten.Vorname" required
                    placeholder="{{'RequiredPlaceholder' | translate}}" type="text" minlength="2">
                  </mat-form-field>
                </div>
                <div class="col-md-6 col-right">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Name' | translate}}</mat-label>
                    <input matInput [(ngModel)]="stammdaten.Name" required
                      placeholder="{{'RequiredPlaceholder' | translate}}" type="text" minlength="2">
                    </mat-form-field>
                  </div>
                </div>
                <!-- Geburstag / Sprache -->
                <div class="row no-padding">
                  <div class="col-md-6 col-left">
                    <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                      <mat-label>{{'Geburtsdatum' | translate}}</mat-label>
                      <input matInput style="margin: 0px" [ngModel]="this.stammdaten.Geburtsdatum | date:'dd.MM.yyyy'"
                        (ngModelChange)="this.stammdaten.Geburtsdatum=this.oroservice.ChangeDate($event);" required
                        placeholder="{{'RequiredPlaceholder' | translate}}" autocomplete='off'>
                        <input type="hidden" [matDatepicker]="pickerVon" [(ngModel)]='this.stammdaten.Geburtsdatum'>
                        <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
                        <mat-datepicker #pickerVon></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6 col-right">
                      <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                        <mat-label>{{'Sprache' | translate}}</mat-label>
                        <mat-select [(ngModel)]="this.stammdaten.Sprache" required
                          placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                          <mat-option [value]="1">DE</mat-option>
                          <mat-option [value]="2">FR</mat-option>
                          <!-- <mat-option [value]="3">IT</mat-option> -->
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <!-- Standort -->
                  <div class="row no-padding">
                    <div class="col-md-8 col-left">
                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                        <mat-label>{{'Anschrift1' | translate}}</mat-label>
                      <input matInput [(ngModel)]="Standort.Anschrift" type="text" required
                        placeholder="{{'RequiredPlaceholder' | translate}}">
                      </mat-form-field>
                    </div>
                    <div class="col-md-4 col-middle">
                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                        <mat-label>{{'Hausnummer' | translate}}</mat-label>
                      <input matInput [(ngModel)]="Standort.Hausnummer" type="text" required
                        placeholder="{{'RequiredPlaceholder' | translate}}">
                      </mat-form-field>
                    </div>
                    <div class="col-md-4 col-right">
                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                        <mat-label>{{'Postfach' | translate}}</mat-label>
                        <input matInput [(ngModel)]="Standort.Postfach" type="text">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row no-padding">
                    <app-postal-code class="no-padding" [(Ort)]="Standort.Ort" [(Plz)]="Standort.Plz" [(Land)]="Standort.Land"
                      [Marginfull]="true">
                    </app-postal-code>
                  </div>
                  <!-- Tel + URL -->
                  <div class="row no-padding">
                    <div class="col-md-4 col-left">
                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                        <mat-label>{{'Stammdaten.Telefongeschaeftlich' | translate}}</mat-label>
                        <input matInput [(ngModel)]="Standort.Telefonnummer" type="text" required
                          placeholder="{{'RequiredPlaceholder' | translate}}">
                          <mat-icon matSuffix class="icon-suffix">local_phone</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-md-4 col-middle">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                          <mat-label>{{'Stammdaten.Telefonprivat' | translate}}</mat-label>
                          <input matInput [(ngModel)]="Standort.Mobilnummer" type="text">
                          <mat-icon matSuffix class="icon-suffix">smartphone</mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-md-4 col-right">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                          <mat-label>{{'Homepage' | translate}}</mat-label>
                          <input matInput [(ngModel)]="Standort.Homepage" type="text">
                          <mat-icon matSuffix class="icon-suffix">language</mat-icon>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }

                <!-- Firma -->
                @if (stammdaten.IstInstitution) {
                  <div>
                    <!-- Firma Name -->
                    <div class="row no-padding">
                      <mat-form-field appearance="fill" class="input-field" style="width:100%; padding: 0px;" floatLabel="always">
                        <mat-label>{{'Stammdaten.Unternehmensname' | translate}}</mat-label>
                        <input matInput [(ngModel)]="stammdaten.Name" required
                          placeholder="{{'RequiredPlaceholder' | translate}}" type="text" minlength="2">
                          <mat-icon matSuffix class="icon-suffix">business</mat-icon>
                        </mat-form-field>
                      </div>
                      <!-- Sprache / EAN / NOGA Code-->
                      <div class="row no-padding">
                        <div class="col-md-4 col-left">
                          <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                            <mat-label>{{'Sprache' | translate}}</mat-label>
                            <mat-select [(ngModel)]="this.stammdaten.Sprache" required
                              placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                              <mat-option [value]="1">DE</mat-option>
                              <mat-option [value]="2">FR</mat-option>
                              <!-- <mat-option [value]="3">IT</mat-option> -->
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-md-4 col-middle">
                          <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'Stammdaten.EAN' | translate}}</mat-label>
                            <input matInput [(ngModel)]="stammdaten.EAN" type="text">
                          </mat-form-field>
                        </div>
                        <div class="col-md-4 col-right">
                          <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'Stammdaten.NogaCode' | translate}}</mat-label>
                            <input matInput [(ngModel)]="stammdaten.NogaCode" type="text">
                          </mat-form-field>
                          @if (!IsNogaValid()) {
                            <mat-error>{{'Stammdaten.NogaCodeError' | translate}}</mat-error>
                          }
                        </div>
                      </div>
                      <!-- Rechtsform / Praxisart -->
                      <div class="row no-padding">
                        <div class="col-md-6 col-left">
                          <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                            <mat-label>{{'Stammdaten.Rechtsform' | translate}}</mat-label>
                            <mat-select [(ngModel)]="this.stammdaten.Rechtsform" required
                              placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                              @for (rechtsform of this.oroservice.kundeninfo.Rechtsformen; track rechtsform) {
                                <mat-option
                                  [value]="rechtsform.Id" [hidden]="rechtsform.Id == 0">
                                  {{rechtsform.Name}}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                        @if (this.oroservice.kundeninfo.HasPraxisart) {
                          <div class="col-md-6 col-right">
                            <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                              <mat-label>{{'Stammdaten.Praxisart' | translate}}</mat-label>
                              <mat-select [(ngModel)]="stammdaten.Praxisart" required
                                placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                                @for (praxisart of this.oroservice.kundeninfo.Praxisarten; track praxisart) {
                                  <mat-option
                                    [value]="praxisart.Id">
                                    {{praxisart.Name}}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        }
                      </div>
                      <!-- Inhaber -->
                      @if (this.stammdaten.Inhaber && (stammdaten.Rechtsform ==2 || stammdaten.Rechtsform ==1)) {
                        <div
                          style="margin-bottom: 22px;">
                          <div class="vertical-center" style="margin:8px;">
                            <mat-icon color="primary">person</mat-icon>&nbsp;<b>{{'Inhaber' | translate}}</b>
                          </div>
                          <div class="outline-blue">
                            <!-- Inhaber Anrede und Titel -->
                            @if (!this.stammdaten.Inhaber.Titel || this.stammdaten.Inhaber.Titel != 20) {
                              <div class="row no-padding"
                                >
                                <div class="col-md-6 col-left">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                                    <mat-label>{{'Stammdaten.Anrede' | translate}}</mat-label>
                                    <mat-select [(ngModel)]="this.stammdaten.Inhaber.Anrede" required
                                      placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                                      <mat-option [value]="1">{{'Neuauftrag.Arzt.Anrede.Herr' | translate}}</mat-option>
                                      <mat-option [value]="2">{{'Neuauftrag.Arzt.Anrede.Frau' | translate}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                <div class="col-md-6 col-right">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
                                    <mat-select [(ngModel)]="this.stammdaten.Inhaber.Titel">
                                      @for (titel of this.oroservice.kundeninfo.Titel; track titel) {
                                        <mat-option [value]="titel.Id">
                                          {{titel.Name}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                              </div>
                            }
                            <!-- Inhaber Anrede und Titel -->
                            @if (this.stammdaten.Inhaber.Titel && this.stammdaten.Inhaber.Titel == 20) {
                              <div class="row no-padding"
                                >
                                <div class="col-md-4 col-left">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                                    <mat-label>{{'Stammdaten.Anrede' | translate}}</mat-label>
                                    <mat-select [(ngModel)]="this.stammdaten.Inhaber.Anrede" required
                                      placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                                      <mat-option [value]="1">{{'Neuauftrag.Arzt.Anrede.Herr' | translate}}</mat-option>
                                      <mat-option [value]="2">{{'Neuauftrag.Arzt.Anrede.Frau' | translate}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                <div class="col-md-4 col-middle">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
                                    <mat-select [(ngModel)]="this.stammdaten.Inhaber.Titel">
                                      @for (titel of this.oroservice.kundeninfo.Titel; track titel) {
                                        <mat-option [value]="titel.Id">
                                          {{titel.Name}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                                <div class="col-md-4 col-right">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                    <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="this.stammdaten.Inhaber.TitelSonstige" placeholder=""
                                      type="text">
                                    </mat-form-field>
                                  </div>
                                </div>
                              }
                              <!-- Inhaber Person Name -->
                              <div class="row no-padding">
                                <div class="col-md-6 col-left">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                    <mat-label>{{'Vorname' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="stammdaten.Inhaber.Vorname" required
                                      placeholder="{{'RequiredPlaceholder' | translate}}" type="text" minlength="2">
                                    </mat-form-field>
                                  </div>
                                  <div class="col-md-6 col-right">
                                    <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                      <mat-label>{{'Name' | translate}}</mat-label>
                                      <input matInput [(ngModel)]="stammdaten.Inhaber.Name" required
                                        placeholder="{{'RequiredPlaceholder' | translate}}" type="text" minlength="2">
                                        <mat-icon matSuffix class="icon-suffix">person</mat-icon>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <!-- Inhaber Geburstag / Sprache -->
                                  <div class="row no-padding">
                                    <div class="col-md-6 col-left">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                        <mat-label>{{'Geburtsdatum' | translate}}</mat-label>
                                        <input matInput style="margin: 0px"
                                          [ngModel]="this.stammdaten.Inhaber.Geburtsdatum | date:'dd.MM.yyyy'"
                                          (ngModelChange)="this.stammdaten.Inhaber.Geburtsdatum=this.oroservice.ChangeDate($event);"
                                          required placeholder="{{'RequiredPlaceholder' | translate}}" autocomplete='off'>
                                          <input type="hidden" [matDatepicker]="pickerVon"
                                            [(ngModel)]='this.stammdaten.Inhaber.Geburtsdatum'>
                                            <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerVon></mat-datepicker>
                                          </mat-form-field>
                                          @if (checkDatumZukunft(this.stammdaten.Inhaber.Geburtsdatum)) {
                                            <div class="col-md-12 no-padding"
                                              >
                                              <label class="warning" style="margin-top: -10px;">{{'DatumZukunft' | translate}}</label>
                                            </div>
                                          }
                                        </div>
                                        <div class="col-md-6 col-right">
                                          <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                                            <mat-label>{{'Sprache' | translate}}</mat-label>
                                            <mat-select [(ngModel)]="this.stammdaten.Inhaber.Sprache" required
                                              placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                                              <mat-option [value]="1">DE</mat-option>
                                              <mat-option [value]="2">FR</mat-option>
                                              <!-- <mat-option [value]="3">IT</mat-option> -->
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                      </div>
                                      <!-- Inhaber Strasse -->
                                      <div class="row no-padding">
                                        <div class="col-md-8 col-left">
                                          <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                            <mat-label>{{'Anschrift1' | translate}}</mat-label>
                                            <input matInput [(ngModel)]="this.stammdaten.Inhaber.Standort.Anschrift" type="text" required
                                              placeholder="{{'RequiredPlaceholder' | translate}}">
                                          </mat-form-field>
                                        </div>
                                        <div class="col-md-4 col-right">
                                          <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                            <mat-label>{{'Hausnummer' | translate}}</mat-label>
                                            <input matInput [(ngModel)]="this.stammdaten.Inhaber.Standort.Hausnummer" type="text" required
                                              placeholder="{{'RequiredPlaceholder' | translate}}">
                                          </mat-form-field>
                                        </div>
                                      </div>
                                      <div class="row no-padding">
                                        <div class="col-md-6 col-left">
                                          <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                            <mat-label>{{'Postfach' | translate}}</mat-label>
                                            <input matInput [(ngModel)]="this.stammdaten.Inhaber.Standort.Postfach" type="text">
                                          </mat-form-field>
                                        </div>
                                        <div class="col-md-6 col-right">
                                          <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                            <mat-label>{{'Adresszusatz' | translate}}</mat-label>
                                            <input matInput [(ngModel)]="this.stammdaten.Inhaber.Standort.Adresszusatz" type="text">
                                          </mat-form-field>
                                        </div>
                                      </div>
                                      <div class="row no-padding">
                                        <app-postal-code class="no-padding" [(Ort)]="this.stammdaten.Inhaber.Standort.Ort"
                                          [(Plz)]="this.stammdaten.Inhaber.Standort.Plz" [(Land)]="this.stammdaten.Inhaber.Standort.Land"
                                        [Marginfull]="true"></app-postal-code>
                                      </div>
                                      <!-- Inhaber Tel -->
                                      <div class="row no-padding">
                                        <div class="col-md-6 col-left">
                                          <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                            <mat-label>{{'Stammdaten.Telefongeschaeftlich' | translate}}</mat-label>
                                            <input matInput [(ngModel)]="this.stammdaten.Inhaber.Standort.Telefonnummer" type="text">
                                            <mat-icon matSuffix class="icon-suffix">local_phone</mat-icon>
                                          </mat-form-field>
                                        </div>
                                        <div class="col-md-6 col-right">
                                          <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                            <mat-label>{{'Stammdaten.Telefonprivat' | translate}}</mat-label>
                                            <input matInput [(ngModel)]="this.stammdaten.Inhaber.Standort.Mobilnummer" type="text">
                                            <mat-icon matSuffix class="icon-suffix">smartphone</mat-icon>
                                          </mat-form-field>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                                <!-- Standorte -->
                                <div class="vertical-center" style="margin: 8px;">
                                  <mat-icon color="primary">mail</mat-icon>&nbsp;<b>{{'Standorte' | translate}}</b>
                                </div>
                                <div class="outline-blue" style="margin-bottom: 28px;">
                                  <div class="row no-padding">
                                    <!-- Standorte -->
                                    <div class="col-md-6 col-left">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                                        <mat-label>{{'Standort' | translate}}</mat-label>
                                        <mat-select [(ngModel)]="this.Standort" required
                                          placeholder="{{'RequiredPlaceholderSelect' | translate}}">
                                          @for (standort of this.stammdaten.Standorte; track standort) {
                                            <mat-option [value]="standort">
                                            {{standort.Name}}</mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                    <div class="col-md-6 col-right">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                        <mat-label>{{'Stammdaten.Auftrittsname' | translate}}</mat-label>
                                        <input matInput [(ngModel)]="Standort.Auftrittsname" type="text">
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <div class="row no-padding">
                                    <div class="col-md-8 col-left">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                        <mat-label>{{'Anschrift1' | translate}}</mat-label>
                                        <input matInput [(ngModel)]="Standort.Anschrift" type="text" required
                                          placeholder="{{'RequiredPlaceholder' | translate}}">
                                      </mat-form-field>
                                    </div>
                                    <div class="col-md-4 col-middle">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                        <mat-label>{{'Hausnummer' | translate}}</mat-label>
                                        <input matInput [(ngModel)]="Standort.Hausnummer" type="text" required
                                          placeholder="{{'RequiredPlaceholder' | translate}}">
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <div class="row no-padding">
                                    <div class="col-md-6 col-left">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%; display:block;" floatLabel="always">
                                        <mat-label>{{'Postfach' | translate}}</mat-label>
                                        <input matInput [(ngModel)]="Standort.Postfach" type="text">
                                      </mat-form-field>
                                    </div>
                                    <div class="col-md-6 col-right">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%; display:block;" floatLabel="always">
                                        <mat-label>{{'Adresszusatz' | translate}}</mat-label>
                                        <input matInput [(ngModel)]="Standort.Adresszusatz" type="text">
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <div class="row no-padding">
                                    <app-postal-code class="no-padding" [(Ort)]="Standort.Ort" [(Plz)]="Standort.Plz"
                                      [(Land)]="Standort.Land" [Marginfull]="true">
                                    </app-postal-code>
                                  </div>
                                  <!-- Tel + URL -->
                                  <div class="row no-padding">
                                    <div class="col-md-4 col-left">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                        <mat-label>{{'Stammdaten.Telefongeschaeftlich' | translate}}</mat-label>
                                        <input matInput [(ngModel)]="Standort.Telefonnummer" type="text" required
                                          placeholder="{{'RequiredPlaceholder' | translate}}">
                                          <mat-icon matSuffix class="icon-suffix">local_phone</mat-icon>
                                        </mat-form-field>
                                      </div>
                                      <div class="col-md-4 col-middle">
                                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                          <mat-label>{{'Stammdaten.Telefonprivat' | translate}}</mat-label>
                                          <input matInput [(ngModel)]="Standort.Mobilnummer" type="text">
                                          <mat-icon matSuffix class="icon-suffix">smartphone</mat-icon>
                                        </mat-form-field>
                                      </div>
                                      <div class="col-md-4 col-right">
                                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                          <mat-label>{{'Homepage' | translate}}</mat-label>
                                          <input matInput [(ngModel)]="Standort.Homepage" type="text">
                                          <mat-icon matSuffix class="icon-suffix">language</mat-icon>
                                        </mat-form-field>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Behandler -->
                                  @if (this.oroservice.kundeninfo.BehandlerAbfrage) {
                                    <div class="vertical-center" style="margin: 8px;">
                                      <mat-icon color="primary">medical_services</mat-icon>&nbsp;<b>{{'Stammdaten.Behandler' | translate}}</b>
                                    </div>
                                  }
                                  @if (this.oroservice.kundeninfo.BehandlerAbfrage) {
                                    <div class="outline-blue" style="margin-bottom: 32px;">
                                      <div class="row no-padding">
                                        <button mat-raised-button color="primary" (click)="NewBehandler()" class="button-standard">
                                          <mat-icon>person_add</mat-icon>&nbsp;
                                          {{'Stammdaten.NeuerBehandler' | translate}}
                                        </button>
                                      </div>
                                      <!-- <div class="row no-padding" *ngIf="this.IsRequesting">
                                      <mat-progress-bar mode="indeterminate" style="margin-top: 4px; margin-bottom: 4px;"></mat-progress-bar>
                                    </div> -->
                                    @if (this.behandlerDatasource.length == 0) {
                                      <div class="row no-padding" style="margin-top: 16px;">
                                        {{'Stammdaten.BehandlerKeine' | translate}}
                                      </div>
                                    }
                                    @if (this.behandlerDatasource.length > 0) {
                                      <div class="row no-padding" style="margin-top: 16px;">
                                        <table mat-table [dataSource]="this.behandlerDatasource" style="width: 100%;" class="mat-elevation-z2">
                                          <ng-container matColumnDef="Name">
                                            <mat-header-cell *matHeaderCellDef>{{'Stammdaten.Behandler' | translate}}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let element">
                                            {{element.Name}}</mat-cell>
                                          </ng-container>
                                          <ng-container matColumnDef="Art">
                                            <mat-header-cell *matHeaderCellDef>{{'Fachrichtung' | translate}}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let element">
                                            {{element.Fachrichtung}}</mat-cell>
                                          </ng-container>
                                          <ng-container matColumnDef="Edit">
                                            <mat-header-cell *matHeaderCellDef>
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let element">
                                              <mat-icon (click)="this.EditBehandler(element)" style="cursor: pointer; margin-right: 4px;">
                                                edit
                                              </mat-icon>&nbsp;
                                              <mat-icon (click)="this.DeleteBehandler(element)"
                                                style="cursor: pointer; margin-right: 4px;">delete
                                              </mat-icon>
                                            </mat-cell>
                                          </ng-container>
                                          <mat-header-row *matHeaderRowDef="behandlerColumns"></mat-header-row>
                                          <mat-row *matRowDef="let row; columns: behandlerColumns;"></mat-row>
                                        </table>
                                      </div>
                                    }
                                    <BR>
                                  </div>
                                }
                              </div>
                            }



                            <!-- Person + Firma -->
                            <!-- Konto -->
                            <div class="vertical-center" style="margin: 8px;">
                              <mat-icon color="primary">payment</mat-icon>&nbsp;<b>{{'Stammdaten.Kontodaten' | translate}}</b>
                            </div>

                            <div class="outline-blue" style="margin-bottom: 19px;">
                              <div class="row no-padding">
                                <div class="col-md-6 col-left">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                    <mat-label>{{'Stammdaten.Kontoinhaber' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="stammdaten.Kontoinhaber" required
                                      placeholder="{{'RequiredPlaceholder' | translate}}" type="text" minlength="2">
                                      <mat-icon matSuffix class="icon-suffix">person</mat-icon>
                                    </mat-form-field>
                                  </div>
                                  <div class="col-md-6 col-right">

                                    <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                      <mat-label>{{'IBAN' | translate}}</mat-label>
                                      <input matInput [(ngModel)]="stammdaten.IBAN" required
                                        placeholder="{{'RequiredPlaceholder' | translate}}" type="text">
                                        <mat-icon matSuffix class="icon-suffix">payment</mat-icon>
                                      </mat-form-field>
                                       @if (stammdaten.IBAN && !IsIbanValid()) {
                                         <div class="col-md-12 no-padding">
                                           <label class="warning">{{'Stammdaten.IbanError' | translate}}</label>
                                         </div>
                                       }
                                    </div>
                                  </div>

                                  <div class="row no-padding">
                                    <div class="col-md-4 col-left">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                        <mat-label>{{'Anschrift1' | translate}}</mat-label>
                                        <input matInput [(ngModel)]="stammdaten.KontoStrasse" type="text" required
                                          placeholder="{{'RequiredPlaceholder' | translate}}">
                                      </mat-form-field>
                                    </div>

                                    <div class="col-md-4 col-middle">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                        <mat-label>{{'Hausnummer' | translate}}</mat-label>
                                        <input matInput [(ngModel)]="stammdaten.KontoHausnummer" type="text" required
                                          placeholder="{{'RequiredPlaceholder' | translate}}">
                                      </mat-form-field>
                                    </div>

                                    <div class="col-md-4 col-right">
                                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                        <mat-label>{{'Postfach' | translate}}</mat-label>
                                        <input matInput [(ngModel)]="stammdaten.KontoPostfach" type="text">
                                      </mat-form-field>
                                    </div>
                                  </div>

                                  <div class="row no-padding">
                                    <app-postal-code class="no-padding" [(Ort)]="stammdaten.KontoOrt" [(Plz)]="stammdaten.KontoPLZ"
                                      [(Land)]="stammdaten.KontoLand" [Marginfull]="true" [OnlyCH]="true">
                                    </app-postal-code>
                                  </div>
                                </div>

                                <!-- Save -->
                                <div class="row no-padding">
                                  <button mat-flat-button color="primary" class="button-standard" style="margin-top: 8px;"
                                    (click)="this.SaveSettings()" [disabled]="!canSubmit()">
                                    <mat-icon>save</mat-icon>
                                    {{'Speichern' | translate}}
                                  </button>
                                </div>
                              </div>
